import { isRecord } from '@/lib/utils'

/**
 * The latest settings a versioned save returns with its 409 conflict, or undefined for any other
 * error. Caching them keeps everything on screen, including terms text, in step with the reset form.
 */
export function versionConflictCurrent(error: unknown): unknown {
  const response = isRecord(error) ? error.response : undefined

  return isRecord(response) && response.status === 409 && isRecord(response.data)
    ? response.data.current
    : undefined
}
